export enum PlayerState {
    Ready = 0,
    Waiting = 1
}